module.exports = __webpack_public_path__ + "img/iron3.3dcdda5d.png";